import {Component, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {LitigeDTO} from "../../../core/dtos/litige-dto";
import {FormControl, FormGroup} from "@angular/forms";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {ToastService} from "../../../core/services/technique/toast.service";
import {LitigesService} from "../../../core/services/entities/litiges.service";
import {UtilsService} from "../../../core/utils/utils.service";
import {SiteDTO} from "../../../core/dtos/site-dto";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";

@Component({
  selector: 'yo-litigeDialog',
  templateUrl: './litige-dialog.component.html',
  styleUrls: ['./litige-dialog.component.scss']
})
export class LitigeDialogComponent implements OnInit {

  subOpenDialog: Subscription

  litige: LitigeDTO;

  form: FormGroup = new FormGroup({});

  dialogTitle: String = 'Modification d\'un litige';

  sitePlaceholder: String = 'Selectionner le site...';

  displayDialog = false;

  idSelectedSite: number;

  constructor(private auth2Svc: Auth2Service,
              private toastSvc: ToastService,
              public litigesSvc: LitigesService,
              public utilsSvc: UtilsService) {
  }

  ngOnInit() {
    this.initForm();
    this.openDialogEditionSubscription();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
  }

  openDialogEditionSubscription = (): void => {
    this.subOpenDialog = this.litigesSvc.openDialogEdition$
      .subscribe((cdt: LitigeDTO) => {
        this.displayDialog = true;
        if (!cdt) {
          this.litige = new LitigeDTO();
          this.litige.id = 0;
          this.dialogTitle = 'Création d\'un litige';
        } else {
          this.litige = cdt;
          this.dialogTitle = 'Modification d\'un litige';
        }
        this.initForm();
      });
  };

  findAllLocalSites = (): SiteDTO[] => {
    return this.auth2Svc.utilisateur.siteListLocaux;
  }

  closeDialog = (): void => {
    this.displayDialog = false;
  };

  save = (): void => {
    if (this.form.valid) {
      let newLitige: LitigeDTO = {...this.litige};
      newLitige.site = {id: this.idSelectedSite} as SiteDTO;
      newLitige.libelle = this.form.controls['libelle'].value;
      newLitige.actif = this.form.controls['actif'].value;
      this.litigesSvc.save(newLitige)
        .subscribe(response => {
          const isUpdate = newLitige.id !== null && newLitige.id !== undefined && newLitige.id !== 0;
          this.litigesSvc.announceLitigeSaved(response.one, isUpdate);
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Sauvegarde du litige réalisée avec succès`);
          this.closeDialog();
        });
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez compléter le formulaire`);
    }
  };

  initForm = (): void => {
    this.sitePlaceholder = !this.canModify() ? this.litige?.site?.libelle : 'Selectionner le site...';
    this.idSelectedSite = this.litige?.site?.id;
    this.form = new FormGroup({
      libelle: new FormControl(this.litige?.libelle),
      actif: new FormControl(this.litige?.actif != null ? this.litige.actif : true)
    });
  };

  onChangeSite = ($event: any): void => {
    this.idSelectedSite = $event.selectedItem?.id;
  }

  canModify = () => {
    return this.litigesSvc.canModify(this.litige);
  }

}

